import React from 'react'

import * as Sentry from '@sentry/browser';
Sentry.init({dsn: "https://dbb5128b359341a9b95d9bbae34e8cdb@o395155.ingest.sentry.io/5246543"});

const SentryInstall = () => (
    <div></div>
);

export default SentryInstall;